import { FC } from 'react';
import CheckIcon from '@mui/icons-material/Check';

export const BooleanCell: FC<{ value: boolean }> = ({ value }) => {
  if (!value) {
    return null;
  }
  return <CheckIcon style={{ color: '#54D62C' }} />;
};
